<template>
  <div v-if="result" class="partner-join">
    <h2 class="partner-join__title">
      {{ result.title }}
    </h2>
    <div class="partner-join-items">
      <PartnerJoinCard
        v-for="(item, key) in result.items"
        :key="item.img + key"
      >
        <template #picture>
          <img :src="item.img" :alt="`img-${ key }`">
        </template>
        <template #title>
          {{ item.title }}
        </template>
        {{ item.text }}
      </PartnerJoinCard>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PartnerJoin',
  props: ['result'],
}
</script>

<style lang="scss" scoped>
.partner-join {
  padding: 85px 100px;
  border: 1px solid #E9EBED;
  border-radius: 6px;
  margin-bottom: 120px;
  @include tablet {
    padding: 44px 24px;
    margin-bottom: 62px;
  }
  @include mobile {
    padding: 24px 16px;
  }

  &__title {
    margin: 0 0 66px;
    text-align: center;
    @include mobile {
      margin-bottom: 36px;
    }
  }
}

.partner-join-items {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-column-gap: 100px;
  @include mobile {
    grid-template-columns: 1fr;
    grid-row-gap: 24px;
  }
}
</style>